import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { SelectSchema } from "@app/components/forms/types/schema";
import { cn } from "@shortsworks/ui/lib/utils";
import { useState, useEffect } from "react";

export const FormMultiSelect = ({
  form,
  schema,
  ...rest
}: FormItemProps<SelectSchema>) => {
  const [selectedValues, setSelectedValues] = useState<string[]>(
    form.getValues()[schema.id],
  ); // 선택된 값들을 배열로 관리

  const handleValueChange = (value: string) => {
    if (selectedValues.includes(value)) {
      return setSelectedValues(selectedValues.filter((item) => item !== value)); // 제거
    } else {
      return setSelectedValues([...selectedValues, value]); // 추가
    }
  };

  useEffect(() => {
    return form.setValue(schema.id, selectedValues);
  }, [selectedValues]);

  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border && "rounded-md border p-3 shadow-sm",
          )}
        >
          <div
            className={cn(
              "space-y-2",
              schema.layout === "horizontal" &&
                "flex flex-row items-start justify-between space-x-2 space-y-0",
            )}
          >
            <div className="flex flex-col space-y-1">
              <FormLabel>
                {typeof schema.label === "function"
                  ? schema.label(form.getValues())
                  : schema.label}
              </FormLabel>
              {schema.layout === "horizontal" && schema.description && (
                <FormDescription>{schema.description}</FormDescription>
              )}
            </div>
            {/*<div>*/}
            <Select onValueChange={handleValueChange} value={field.value}>
              <FormControl>
                <SelectTrigger
                  id={schema.id}
                  className={cn(
                    "items-center [&_[data-description]]:hidden overflow-x-hidden",
                    schema.layout === "horizontal" && "w-fit",
                  )}
                >
                  <div>
                    {
                      // 다른 형태로 작성 필요
                      selectedValues.length === 0
                        ? schema.placeholder
                        : selectedValues
                            .map((value) => {
                              const selectedOption = schema.options.find(
                                (option) => option.value === value,
                              );
                              return selectedOption?.label;
                            })
                            .join(",")
                    }
                  </div>
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {schema.options?.map((option: any) => (
                  <SelectItem
                    className={
                      selectedValues.includes(option.value) && "bg-secondary"
                    }
                    key={option.value}
                    value={option.value}
                  >
                    <div className="flex items-start gap-3 text-muted-foreground">
                      {option.icon}
                      <div className="grid gap-0.5">
                        <p>
                          <span className="font-medium text-foreground">
                            <FormLabel>
                              {typeof schema.label === "function"
                                ? option.label(form.getValues())
                                : option.label}
                            </FormLabel>
                          </span>
                        </p>
                        {option.description && (
                          <div className="text-xs" data-description>
                            {option.description}
                          </div>
                        )}
                      </div>
                    </div>
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {/*</div>*/}
            {schema.layout !== "horizontal" && schema.description && (
              <FormDescription>
                {typeof schema.description === "function"
                  ? schema.description(form.getValues())
                  : schema.description}
              </FormDescription>
            )}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
